import { Button } from '@savvy-kit/components/button/button';
import { Trash2 } from 'lucide-react';

import { formatFileSize } from '../file-drop-zone';
import { getFileIcon } from './utils/get-file-icon';
import { useFileAttachmentContext } from './with-file-upload';

export type FilePreviewListProps = {
  files?: File[];
  onRemove?: (index: number) => void;
  disabled?: boolean;
};

export function FilePreviewList({
  files: filesProp,
  onRemove: onRemoveProp,
  disabled: disabledProp,
}: FilePreviewListProps) {
  const ctx = useFileAttachmentContext();
  const files = filesProp ?? ctx?.files ?? [];
  const onRemove = onRemoveProp ?? ctx?.removeFile;
  const disabled = disabledProp ?? ctx?.disabled ?? false;

  if (files.length === 0) return null;

  return (
    <ul className="mt-2 text-sm text-foreground">
      {files.map((file, index) => {
        const Icon = getFileIcon(file.name);
        return (
          <li
            key={`${file.name}-${index}`}
            className="flex items-center justify-between gap-2 border-b border-slate-300 py-2 last:border-b-0"
          >
            <div className="flex min-w-0 items-center gap-2">
              <Icon size={20} />
              <span className="truncate">{file.name}</span>
            </div>
            <div className="flex shrink-0 items-center gap-2">
              <span className="text-secondary tabular-nums">{formatFileSize(file.size)}</span>
              <Button
                variant="ghost"
                size="sm"
                type="button"
                disabled={disabled}
                onClick={() => onRemove?.(index)}
                className="text-destructive"
                aria-label={`Remove file ${file.name}`}
                icon={<Trash2 className="size-4 text-destructive" />}
              />
            </div>
          </li>
        );
      })}
    </ul>
  );
}
